import { cn } from "@repo/utils";
import type { SelectOption, SelectOptionValue } from "../inputs/select/select.js";
import { Checkbox } from "../ui/checkbox.js";
import { ScrollArea } from "../ui/scroll-area.js";

type Props = {
  title: string;
  options: SelectOption<SelectOptionValue>[];
  selectedValues: string[];
  onCheckboxChange: (value: string, checked: boolean) => void;
  idPrefix: string;
  className?: string;
  titleClassName?: string;
  labelClassName?: string;
  checkboxClassName?: string;
  scrollAreaClassName?: string;
};

export const CheckboxGroup = ({
  title,
  options,
  selectedValues,
  onCheckboxChange,
  idPrefix,
  className,
  titleClassName,
  labelClassName = "cursor-pointer text-sm",
  checkboxClassName,
  scrollAreaClassName = "h-fit",
}: Props) => {
  return (
    <div className={className || "space-y-3"}>
      <h3 className={titleClassName || "text-sm font-semibold"}>{title}</h3>
      <ScrollArea className={scrollAreaClassName}>
        <div className="space-y-2">
          {options.map((option) => {
            const optionValueStr = String(option.value);
            return (
              <div
                key={option.value}
                className="hover:bg-gxe-bg-light flex w-fit items-center space-x-2 rounded"
              >
                <Checkbox
                  id={`${idPrefix}-${option.value}`}
                  checked={selectedValues.includes(optionValueStr)}
                  onCheckedChange={(checked: boolean) => onCheckboxChange(optionValueStr, checked)}
                  className={cn("cursor-pointer", checkboxClassName)}
                />
                <label
                  htmlFor={`${idPrefix}-${option.value}`}
                  className={cn(labelClassName, {
                    "text-black": selectedValues.includes(optionValueStr),
                  })}
                >
                  {option.label}
                </label>
              </div>
            );
          })}
        </div>
      </ScrollArea>
    </div>
  );
};

CheckboxGroup.displayName = "CheckboxGroup";
